<template>
  <div class="main-content">
    <!-- BradCrumb header Start-->
    <section class="inner-header-bg">
      <div class="container">
        <!-- Breadcrumb Start-->
        <div class="section-breadcrumb">
          <div class="container">
            <div class="row">
              <div
                class="col-md-12 justify-content-center align-self-center pb-2"
              >
                <div class="breadcrumb-content">
                  <div class="title-section">
                    <h1 class="title text-center text-white">
                      Event and News Details
                    </h1>
                  </div>
                  <div class="breadcrumb-nav">
                    <ul class="breadcrumb-link text-center list-unstyled mb-0">
                      <li class="text-white">
                        <i class="mdi mdi-home theme-light-color pr-2"></i>
                        <a href="index.html">Home</a>
                      </li>
                      <li class="theme-light-color active">
                        Event and News Details
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Breadcrumb End -->
      </div>
    </section>
    <!-- BradCrumb header End -->
    <!-- Blog Details Start-->
    <section class="section section-blog">
      <div class="container">
        <div class="row">
          <div
            class="col-lg-8 order-lg-1 mt-lg-0 mt-4 wow fadeIn"
            data-wow-delay="0.1s"
            data-wow-duration="1.5s"
          >
            <article class="blog-post-left border">
              <div class="row">
                <div class="col-lg-12">
                  <div class="post-image">
                    <a href="#">
                      <img
                        :src="image"
                        class="img-fluid img-thumbnail border-0"
                      />
                    </a>
                  </div>
                  <div class="post-content">
                    <div class="post-event d-flex align-items-center my-3">
                      <h4>
                        <strong> {{ title }} </strong>
                      </h4>
                    </div>
                    <div v-html="text"></div>
                    <div v-if="iswp == true">
                      <div class="col-lg-12 col-12">
                        <form
                          action=""
                          @submit.prevent="sendEmail"
                          class="wpcf7-form init"
                          novalidate="novalidate"
                          data-status="init"
                        >
                          <div class="mt-5">
                            <div class="row">
                              <div class="col-sm-6 col-12">
                                <div class="form-group">
                                  <input
                                    type="text"
                                    class="form-control"
                                    name="name"
                                    v-model="name"
                                    placeholder="Enter name"
                                    required="required"
                                  />
                                </div>
                              </div>
                              <div class="col-sm-6 col-12">
                                <div class="form-group">
                                  <input
                                    type="email"
                                    class="form-control"
                                    name="email"
                                    v-model="email"
                                    placeholder="Enter email"
                                    required="required"
                                  />
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-sm-12">
                                  <button
                                    type="submit"
                                    name="submit"
                                    value="Send"
                                    class="btn theme-btn w-100 rounded"
                                  >
                                    Click to Download Whitepaper
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </article>
          </div>
          <div
            class="col-lg-4 order-lg-2 wow fadeIn"
            data-wow-delay="0.1s"
            data-wow-duration="1.5s"
          >
            <aside class="sidebar sidebar-padding border">
              <div class="tags-post">
                <ul class="blog-news list-unstyled">
                  <li class="blog-item">
                    <h6 class="post-news-title">Tags</h6>
                  </li>
                </ul>

                <div class="blog-news-content">
                  <div class="blog-post-list">
                    <ul class="list-unstyled list-inline mb-0">
                      <li class="list-inline-item">
                        <div class="blog-news-info">
                          <a href="#" class="text-dark">Technical </a>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </aside>
          </div>
        </div>
      </div>
    </section>
    <!-- Blog Details Section End-->
  </div>
</template>
<script>
import emailjs from "emailjs-com";

export default {
  name: "blogdetail",
  data() {
    return {
      id: this.$route.params.id,
      image: this.$route.params.image,
      text: this.$route.params.text,
      title: this.$route.params.title,
      summary: this.$route.params.summary,
      date: this.$route.params.date,
      wppdf: this.$route.params.pdf,
      iswp: this.$route.params.iswp,
      name: "",
      email: "",
      message: "",
      errors: [],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.initFooterHeight();
    },
    initFooterHeight() {
      var footerHeight = $("footer").outerHeight();
      $(".main-content").css("margin-bottom", footerHeight);
    },
    sendEmail(e) {
      this.errors = [];
      if (!this.name) this.errors.push("Name required.");
      if (!this.email) this.errors.push("Email required.");
      if (!this.message) this.errors.push("Message required.");
      if (this.name && this.email) {
        try {
          emailjs.sendForm(
            "service_888e61q",
            "template_av4z7ua",
            e.target,
            "user_pOxKObRIUjM12T65F08qW"
          );
        } catch (error) {
          console.log({ error });
        }
        // Reset form field
        this.name = "";
        this.email = "";
        window.open(this.wppdf);
      }
    },
  },
};
</script>
